import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';

import { Horse_show_with_entries } from '../models/horse_show_with_entries';
import { Horse_show_entry_with_type } from '../models/horse_show_entry_with_type';
import { Statement } from '../models/accounting/statement';

import { AppSettings } from '../app.settings';

@Injectable({
  providedIn: 'root'
})
export class HorseShowWithEntriesService {

  constructor(private http: HttpClient) { }


  getUnsubmittedEntriesForUser(): Promise<Horse_show_with_entries[]> {
  	  return this.getListWithRESTUrlFilter("submitted/false/user/true/statement/false/competitions/true/entry_type/true/location/usa");
  }

  getSubmittedEntriesForUser(): Promise<Horse_show_with_entries[]> {
      return this.getListWithRESTUrlFilter("submitted/true/user/true/statement/false/competitions/false/entry_type/true/location/usa");
  }

  private getListWithRESTUrlFilter(rest_url: string): Promise<Horse_show_with_entries[]> {

		return new Promise((resolve, reject) => {

			return this.http.get(AppSettings.API_ENDPOINT + 'horse_shows_with_entries/' + rest_url).subscribe((response:any) => {

		      if(response.type == 'horse_shows_with_entries' && response.data){
		        resolve(response.data);
		      } else {
		        reject(response);
		      }

		    },
		      error => {
				if(error instanceof HttpErrorResponse){
            	  reject(error.error);
            	} else {
            		reject(error);
            	}
		      });
		  });
	 }

}
